'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.millisecond;


// WEBPACK FOOTER //
// ./~/sugar-date/number/millisecond.js